import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { toastFactory } from '@/factories'
import { selectIsAuth } from '@/reducers/userDataReducer'
import { consumeImpersonationNotice } from '@/utils/auth'

/**
 * Toasts why the session just switched back to the support account. The switch is a hard reload,
 * so the reason is carried over in sessionStorage and picked up here once the app is back up.
 */
export const ImpersonationNotice = () => {
  const { t } = useTranslation(['user-panel'])
  const isAuth = useSelector(selectIsAuth)

  useEffect(() => {
    const notice = consumeImpersonationNotice()
    // The restored session itself can fail to verify, landing on login — nothing to announce then.
    if (!notice || !isAuth) return

    if (notice === 'expired') toastFactory.error(t('user-panel:impersonation.notice.expired'))
    else toastFactory.success(t('user-panel:impersonation.notice.ended'))
  }, [isAuth, t])

  return null
}
